// @ts-nocheck

import React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import MPCardDetailsInfo from '../components/common/MPCardDetailsInfo';
import MPHistoryItemContainer from '../containers/MPHistoryItemContainer';
import { useMPFamilyContext } from '../contexts/MPFamilyContext';
import { selectMPFamilyInfo } from '../selectors/families';

type MPCardDetailsInfoContainerProps = {
  className?: string;
  betslipReference?: string;
};

const MPCardDetailsInfoContainer = ({ betslipReference, ...ownProps }: MPCardDetailsInfoContainerProps) => {
  const { familyId } = useMPFamilyContext();
  const familyInfo = useSelector((state) => selectMPFamilyInfo(state, { familyId }));

  const selectedProps = useMemo(
    () => (familyInfo ? { ...familyInfo.eligibility, ...familyInfo.rules } : null),
    [familyInfo],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  if (betslipReference) {
    return <MPHistoryItemContainer betslipReference={betslipReference} isCashoutHidden />;
  }

  if (familyInfo) {
    return <MPCardDetailsInfo {...enhancedProps} />;
  }

  return null;
};

export default MPCardDetailsInfoContainer;
